import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

// function isMobileDevice() {
//   const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
//   return width < 768; // 假设小于 768px 为移动端
// }

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)',
    name: 'redirect',
    redirect: '/',
    // component: () => import('../views/login/LoginView.vue'),
  },
  {
    path: '/',
    name: 'unipass',
    component: () => {
      // if (isMobileDevice()) {
      //   return import('../views/login/LoginPhoneView.vue')
      // }
      return import('../views/login/LoginView.vue')
    }
  },
  {
    path: '/loginWelcome',
    name: 'loginWelcome',
    component: () => import('../views/login/loginWelcome.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
